import * as React from 'react'
import styled from 'styled-components'
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

const Container = styled.div`
  background-color: rgb(255, 255, 255);
  border: 1px solid rgb(245, 245, 245);
  border-radius: 12px;
  box-shadow: rgba(9, 14, 21, 0.16) 0px 0px 4px 0px;
  width: 330px;
  height: 260px;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 2147483001;
  margin: 0px 30px;
`

const Wrapper = styled.div`


  em-emoji-picker {
    width: 330px !important;
    max-width: 330px !important;
  } 

  #preview {
    display: none;
  }
`

interface IProps {
  onEmojiSelect: (emoji: {
    (...data: any[]): void;
    (message?: any, ...optionalParams: any[]): void;
  }) => void
}

const EmojiPopover = (props: IProps) => {
  const { onEmojiSelect } = props
  return (
    <Container>
      <Wrapper>
        <Picker
          data={data}
          onEmojiSelect={onEmojiSelect}
          maxFrequentRows={2}
          perLine={8}
        />
      </Wrapper>
    </Container>
  )
}

export default EmojiPopover